import { AT_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import { createSuggestionPlugin } from 'hubspot-prosemirror/prosemirror/plugins/suggestion';
import { getMatchResults } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { Plugin } from 'hubspot-prosemirror/pm/state';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PortalIdParser from 'PortalIdParser';
import { AtMentionSuggestionsComponent } from './AtMentionSuggestionsComponent';
import { jsx as _jsx } from "react/jsx-runtime";
function MatchesNotFound({
  text
}) {
  return /*#__PURE__*/_jsx("div", {
    children: text ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "atMentionPlugin.notFound",
      options: {
        search: text,
        uri: `/settings/${PortalIdParser.get()}/users/new`
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "atMentionPlugin.notFoundEmpty"
    })
  });
}
function getMentionIds(state) {
  const ids = new Set();
  const nodeType = state.schema.nodes.atmention;
  if (!nodeType) return ids;
  state.doc.descendants(node => {
    if (node.type === nodeType) {
      ids.add(Number(node.attrs.id));
    }
  });
  return ids;
}
function setsEqual(a, b) {
  if (a.size !== b.size) return false;
  for (const val of a) {
    if (!b.has(val)) return false;
  }
  return true;
}
function createMentionWatcherPlugin(allOptions, onMentionsChanged) {
  const optionById = new Map(allOptions.map(opt => [Number(opt.id), opt]));
  return new Plugin({
    view: () => ({
      update: (view, prevState) => {
        if (prevState.doc === view.state.doc) return;
        const prevIds = getMentionIds(prevState);
        const currentIds = getMentionIds(view.state);
        if (setsEqual(prevIds, currentIds)) return;
        const mentions = [...currentIds].map(id => optionById.get(id)).filter(opt => opt !== undefined);
        onMentionsChanged(mentions);
      }
    })
  });
}
export const configureMentionsPlugin = (mentionOptions, options) => {
  const plugin = createSuggestionPlugin(Object.assign({
    getSuggestions: (text, done) => {
      done(getMatchResults(text, mentionOptions, {
        sortAlphabetically: true
      }));
    },
    type: AT_MENTION,
    NotFoundComponent: MatchesNotFound,
    getSuggestionsComponent: props => /*#__PURE__*/_jsx(AtMentionSuggestionsComponent, Object.assign({}, props))
  }, (options === null || options === void 0 ? void 0 : options.onMentionSelected) && {
    fetchSelectSuggestion: ({
      snippet,
      handleInsert
    }) => {
      options.onMentionSelected(snippet);
      handleInsert(snippet);
    }
  }));
  plugin._suggestionType = AT_MENTION;
  const plugins = [plugin];
  if (options !== null && options !== void 0 && options.onMentionsChanged) {
    plugins.push(createMentionWatcherPlugin(mentionOptions, options.onMentionsChanged));
  }
  return plugins;
};